<div class="form-group custom-tab-content ui-g-12"
	[attr.tab-key]="field.props.label"
	[ngClass]="{
		'visually-hidden': (field.props.visible === false)
	}">
	<ng-container #fieldComponent>
	</ng-container>
</div>